module.exports = __webpack_public_path__ + "static/slide2.80a44c4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lego/slide2.png
// module id = 524
// module chunks = 35783957827783